import React from 'react';
import { Phone, AlertTriangle, CheckCircle, HelpCircle, FileText, Scale } from 'lucide-react';
export function MichiganDotInspectionPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-5342">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-5343">
        <div className="container mx-auto px-4" data-id="element-5344">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-5345">
            Michigan DOT Inspection
          </h1>
          <p className="text-2xl text-gray-100 text-center font-bold" data-id="element-5346">
            DO I NEED A DOT INSPECTION?
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-5347">
        <div className="max-w-4xl mx-auto" data-id="element-5348">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5349">
            <p className="text-lg text-gray-700 mb-6" data-id="element-5350">
              Do you need a DOT inspection in Michigan? The answer depends on a
              variety of factors. We break it down here on our Michigan DOT
              Inspection page.
            </p>

            <p className="text-lg text-gray-700 mb-4" data-id="element-5351">
              Garrett Auto & Truck Service offers Michigan Department of
              Transportation (MDOT) inspections for all qualifying commercial
              vehicles and trailers, ensuring safe and legal operations across
              Southeast Michigan.
            </p>

            <p className="text-lg text-gray-700" data-id="element-5352">
              The Michigan Department of Transportation requires all commercial
              vehicles to be inspected annually if they meet these requirements.
            </p>
          </div>

          {/* Need Help CTA */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-6 mb-8 text-center" data-id="element-5353">
            <p className="text-xl" data-id="element-5354">
              <strong className="text-red-600" data-id="element-5355">
                I DONT HAVE TIME TO READ THIS
              </strong>{' '}
              <a href="/contact" className="text-blue-600 hover:underline font-bold italic" data-id="element-5356">
                Click Here
              </a>{' '}
              <strong className="text-red-600" data-id="element-5357">FOR HELP</strong>
            </p>
          </div>

          {/* DOT Information */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5358">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5359">
              DOT Information For Commercial & Company Vehicles
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-5360">
              <p className="text-lg text-gray-700" data-id="element-5361">
                If your vehicle and trailer exceed 10,000 lbs, you will need DOT
                inspection performed on both. All trailers must be DOT
                inspected.
              </p>
            </div>

            <div className="space-y-4 mb-6" data-id="element-5362">
              <div className="bg-green-50 rounded-lg p-4" data-id="element-5363">
                <p className="text-gray-800" data-id="element-5364">
                  <strong data-id="element-5365">Trailers under 15,000 lbs:</strong> Only requires
                  brake system on single axle of twin axle trailers
                </p>
              </div>

              <div className="bg-yellow-50 rounded-lg p-4" data-id="element-5366">
                <p className="text-gray-800" data-id="element-5367">
                  <strong data-id="element-5368">Trailers over 15,000 lbs:</strong> Will need brakes on
                  both axles
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-6" data-id="element-5369">
              <p className="text-gray-700 mb-4" data-id="element-5370">
                This is a basic explanation of DOT regulations. If more detailed
                information is needed, please contact DOT or give us a call if
                you want to set up a DOT inspection.
              </p>
              <ul className="space-y-2 text-gray-700" data-id="element-5371">
                <li data-id="element-5372">
                  * DOT annual inspection stickers are separate from the actual
                  DOT numbers found on the side of commercial vehicles
                </li>
                <li data-id="element-5373">
                  * Phone number to DOT:{' '}
                  <a href="tel:18006824682" className="text-blue-600 hover:underline" data-id="element-5374">
                    1-800-682-4682
                  </a>
                </li>
                <li data-id="element-5375">
                  * Link to DOT website -{' '}
                  <a href="https://www.fmcsa.dot.gov/regulations" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-5376">
                    DOT Website
                  </a>
                </li>
                <li data-id="element-5377">
                  * Link to -{' '}
                  <a href="https://www.fmcsa.dot.gov/sites/fmcsa.dot.gov/files/docs/part-396form6.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-5378">
                    DOT Inspection Form
                  </a>
                </li>
                <li data-id="element-5379">
                  * Link to Federal DOT website for the long Federal over the
                  road numbers -{' '}
                  <a href="https://www.transportation.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-5380">
                    Federal DOT website
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Limousine Inspections */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5381">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5382">
              Limousine Inspections
            </h2>
            <p className="text-lg text-gray-700 mb-4" data-id="element-5383">
              Each limousine must have an annual safety inspection conducted by
              a currently certified mechanic at a registered repair facility on
              an MDOT form 3049 or 3049E.
            </p>
            <div className="bg-purple-50 border-l-4 border-purple-500 p-4" data-id="element-5384">
              <p className="text-gray-800" data-id="element-5385">
                Limousine inspections must be performed on all vehicles hauling{' '}
                <strong data-id="element-5386">15 passengers or less including driver</strong>.
              </p>
            </div>
          </div>

          {/* Weight Definitions */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5387">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-5388">
              <Scale className="mr-3 text-[#B1050B]" size={28} data-id="element-5389" />
              Weight Definitions & Calculations
            </h2>

            <div className="space-y-4" data-id="element-5390">
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-5391">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5392">
                  Gross Combination Weight (GCW)
                </h3>
                <p className="text-gray-700" data-id="element-5393">
                  Total weight of a fully equipped truck and trailer with cargo,
                  driver, and passengers, fuel, coolant, equipment, etc.
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-4" data-id="element-5394">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5395">
                  Gross Combination Weight Rating (GCWR)
                </h3>
                <p className="text-gray-700" data-id="element-5396">
                  Maximum allowable gross combination weight (GCW)
                </p>
              </div>

              <div className="bg-yellow-50 rounded-lg p-4" data-id="element-5397">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5398">
                  Gross Trailer Weight (GTW)
                </h3>
                <p className="text-gray-700" data-id="element-5399">
                  The weight of the trailer plus all the cargo in it. This is
                  measured by putting a fully loaded trailer on a scale.
                </p>
              </div>

              <div className="bg-purple-50 rounded-lg p-4" data-id="element-5400">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5401">
                  Gross Trailer Weight Rating (GTWR)
                </h3>
                <p className="text-gray-700" data-id="element-5402">
                  Maximum allowable weight of the trailer, plus its cargo.
                </p>
              </div>

              <div className="bg-red-50 rounded-lg p-4" data-id="element-5403">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5404">
                  Gross Vehicle Weight (GVW)
                </h3>
                <p className="text-gray-700" data-id="element-5405">
                  The total weight of the tow vehicle, including driver,
                  passengers, and any special equipment (options, accessories
                  and upfitted equipment), cargo, fuel, coolant, etc.
                </p>
              </div>

              <div className="bg-indigo-50 rounded-lg p-4" data-id="element-5406">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5407">
                  Gross Vehicle Weight Rating (GVWR)
                </h3>
                <p className="text-gray-700" data-id="element-5408">
                  The maximum allowable total weight of the tow vehicle,
                  including driver, passengers, any special equipment (options,
                  accessories and upfitted equipment), cargo, fuel, coolant,
                  etc.
                </p>
              </div>
            </div>
          </div>

          {/* Quick Recap */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-5409">
            <h2 className="text-3xl font-bold mb-6" data-id="element-5410">Quick Recap</h2>

            <h3 className="text-2xl font-bold mb-4" data-id="element-5411">
              Who Needs a DOT Inspection?
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-5412">
              <li className="flex items-start" data-id="element-5413">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5414" />
                <span data-id="element-5415">
                  If your vehicle or trailer exceeds 10,000 lbs (GVW or GCW),
                  both require MDOT inspection
                </span>
              </li>
              <li className="flex items-start" data-id="element-5416">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5417" />
                <span data-id="element-5418">
                  Trailers under 15,000 lbs need inspection of the brake system
                  on a single-axle or twin-axle configuration
                </span>
              </li>
              <li className="flex items-start" data-id="element-5419">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5420" />
                <span data-id="element-5421">
                  Trailers over 15,000 lbs require brake inspections on both
                  axles
                </span>
              </li>
            </ul>

            <p className="text-gray-200" data-id="element-5422">
              Stickers from annual inspections are separate from DOT numbers
              displayed on your vehicle body.
            </p>
          </div>

          {/* Why Choose Garrett Auto */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5423">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-5424">
              Why Choose Garrett Auto for Your DOT Inspection?
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-5425">
              <div className="text-center" data-id="element-5426">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5427">
                  <CheckCircle className="text-blue-600" size={32} data-id="element-5428" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5429">
                  Certified Technicians
                </h3>
                <p className="text-gray-700" data-id="element-5430">
                  Deep expertise in MDOT protocols
                </p>
              </div>

              <div className="text-center" data-id="element-5431">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5432">
                  <FileText className="text-green-600" size={32} data-id="element-5433" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5434">
                  Convenient Location
                </h3>
                <p className="text-gray-700" data-id="element-5435">
                  Farmington Hills, serving Brighton, Novi, Livonia, Commerce,
                  and nearby areas
                </p>
              </div>

              <div className="text-center" data-id="element-5436">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5437">
                  <AlertTriangle className="text-purple-600" size={32} data-id="element-5438" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5439">
                  Fast & Reliable
                </h3>
                <p className="text-gray-700" data-id="element-5440">
                  Minimize downtime for your fleet
                </p>
              </div>
            </div>

            <p className="text-center text-gray-700 mt-6" data-id="element-5441">
              Need clarification on regulations or assistance interpreting DOT
              forms? We've got your back.
            </p>
          </div>

          {/* What is a CMV */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5442">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-5443">
              What is a Commercial Motor Vehicle (CMV)?
            </h2>

            <p className="text-lg text-gray-700 mb-4" data-id="element-5444">
              You are operating a commercial motor vehicle if you transport
              passengers or property in a vehicle that:
            </p>

            <div className="space-y-4" data-id="element-5445">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-5446">
                <p className="text-gray-800 mb-2" data-id="element-5447">
                  <strong data-id="element-5448">
                    Has an actual gross vehicle weight (GVW) or gross
                    combination vehicle weight (GCW) of 10,001 pounds or more
                  </strong>
                </p>
                <ul className="ml-4 space-y-1 text-gray-700" data-id="element-5449">
                  <li data-id="element-5450">• GVW means the weight of a vehicle and its load</li>
                  <li data-id="element-5451">
                    • GCW means the weight of a combination vehicle and its load
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 border-l-4 border-green-500 p-4" data-id="element-5452">
                <p className="text-gray-800 mb-2" data-id="element-5453">
                  <strong data-id="element-5454">
                    Has a gross vehicle weight rating (GVWR) or gross
                    combination weight rating (GCWR) of 10,001 pounds or more
                  </strong>
                </p>
                <ul className="ml-4 space-y-1 text-gray-700" data-id="element-5455">
                  <li data-id="element-5456">
                    • GVWR is the value specified by the manufacturer as a safe
                    loaded weight of a single vehicle (the GVWR is located on
                    the manufacturer's tag, usually found inside the driver's
                    side door)
                  </li>
                  <li data-id="element-5457">
                    • GCWR is the value specified by the manufacturer as the
                    loaded weight of a combination of vehicles
                  </li>
                  <li data-id="element-5458">
                    • As used here, a combination vehicle means a truck pulling
                    another vehicle or trailer
                  </li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-5459">
                <ul className="space-y-1 text-gray-700" data-id="element-5460">
                  <li data-id="element-5461">
                    • Is designed or used to carry 16 or more passengers,
                    including the driver
                  </li>
                  <li data-id="element-5462">
                    • Is transporting hazardous materials (in amounts that
                    require placarding)
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* It Does Not Matter */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-5463">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-5464">
              IT does not matter if you:
            </h3>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-6" data-id="element-5465">
              <li data-id="element-5466">Are not for-hire</li>
              <li data-id="element-5467">Only transport company property</li>
              <li data-id="element-5468">Are the owner or only driver</li>
            </ol>

            <p className="text-gray-800 mb-4" data-id="element-5469">
              <strong data-id="element-5470">
                If your vehicle meets the criteria for a commercial motor
                vehicle, the following rules, regulations and laws may apply to
                the company, the vehicle and all drivers:
              </strong>
            </p>

            <ul className="space-y-2 text-gray-700" data-id="element-5471">
              <li className="flex items-start" data-id="element-5472">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5473" />
                <span data-id="element-5474">Chauffeur Driver License</span>
              </li>
              <li className="flex items-start" data-id="element-5475">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5476" />
                <span data-id="element-5477">Commercial Driver License (CDL)</span>
              </li>
              <li className="flex items-start" data-id="element-5478">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5479" />
                <span data-id="element-5480">
                  Driver Qualifications (i.e., medical cards, driver files,
                  state driving record)
                </span>
              </li>
              <li className="flex items-start" data-id="element-5481">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5482" />
                <span data-id="element-5483">Driver Drug and Alcohol Testing</span>
              </li>
              <li className="flex items-start" data-id="element-5484">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5485" />
                <span data-id="element-5486">Hours of Service</span>
              </li>
              <li className="flex items-start" data-id="element-5487">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5488" />
                <span data-id="element-5489">Log Books</span>
              </li>
              <li className="flex items-start" data-id="element-5490">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5491" />
                <span data-id="element-5492">
                  Hazardous Material Regulations (applies to gasoline, oxygen,
                  acetylene, fertilizer or other hazardous materials, regardless
                  of the amount you carry)
                </span>
              </li>
              <li className="flex items-start" data-id="element-5493">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5494" />
                <span data-id="element-5495">
                  Vehicle Equipment Compliance (required equipment, daily and
                  annual inspection reports, cargo securement)
                </span>
              </li>
              <li className="flex items-start" data-id="element-5496">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5497" />
                <span data-id="element-5498">Size and Weight (pertains to all vehicles)</span>
              </li>
              <li className="flex items-start" data-id="element-5499">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5500" />
                <span data-id="element-5501">Fuel Tax and IRP Registration</span>
              </li>
              <li className="flex items-start" data-id="element-5502">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5503" />
                <span data-id="element-5504">Minimum Amounts of Insurance</span>
              </li>
            </ul>
          </div>

          {/* FAQ Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5505">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-5506">
              <HelpCircle className="mr-3 text-blue-600" size={28} data-id="element-5507" />
              F.A.Q. Section
            </h2>

            <div className="space-y-6" data-id="element-5508">
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-5509">
                <p className="font-bold text-gray-900 mb-2" data-id="element-5510">
                  Q: Are limousines inspected?
                </p>
                <p className="text-gray-700" data-id="element-5511">
                  A: Yes. Vehicles carrying 15 passengers (including the driver)
                  require annual MDOT inspections using form 3049 or 3049E
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-5512">
                <p className="font-bold text-gray-900 mb-2" data-id="element-5513">
                  Q: What weights qualify as a commercial motor vehicle (CMV)?
                </p>
                <p className="text-gray-700" data-id="element-5514">
                  A: Any vehicle combination with a GVW or GCW over 10,001 lbs,
                  those transporting passengers, or hazardous materials may be
                  subject to CMV regulations.
                </p>
              </div>
            </div>
          </div>

          {/* Compliance Quiz */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5515">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5516">
              Take this simple compliance indicator quiz!
            </h2>

            <div className="space-y-6" data-id="element-5517">
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-5518">
                <p className="text-lg text-gray-800 mb-2" data-id="element-5519">
                  Do you use a small truck (box van, step van), a pickup towing
                  a trailer or a small bus in your business?
                </p>
                <p className="text-gray-600" data-id="element-5520">☐ Yes ☐ No</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6" data-id="element-5521">
                <p className="text-lg text-gray-800 mb-3" data-id="element-5522">
                  Is your vehicle used to transport:
                </p>
                <ul className="space-y-1 text-gray-700 mb-3" data-id="element-5523">
                  <li data-id="element-5524">• A product</li>
                  <li data-id="element-5525">• Passengers</li>
                  <li data-id="element-5526">• Tools and/or supplies used in your trade</li>
                  <li data-id="element-5527">
                    • Any amount of a hazardous material (gasoline, oxygen,
                    acetylene, propane, paint, solvents, glues, fertilizer,
                    etc.)
                  </li>
                </ul>
                <p className="text-gray-600" data-id="element-5528">☐ Yes ☐ No</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6" data-id="element-5529">
                <p className="text-lg text-gray-800 mb-2" data-id="element-5530">
                  Do you personally own, lease or use your employee's vehicles
                  in your business?
                </p>
                <p className="text-gray-600" data-id="element-5531">☐ Yes ☐ No</p>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6" data-id="element-5532">
                <p className="text-gray-800 mb-4" data-id="element-5533">
                  <strong data-id="element-5534">
                    If you answered yes to one or more of these questions, some
                    or all of the federal and state safety regulations may apply
                    to your company, your vehicles and the people who drive
                    them.
                  </strong>
                </p>
                <p className="text-gray-700" data-id="element-5535">
                  State and local enforcement agencies understand and enforce
                  these regulations. It is important that you understand them as
                  well. Violations are subject to both civil and criminal
                  penalties.
                </p>
              </div>
            </div>
          </div>

          {/* Final CTA */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-5536">
            <h2 className="text-3xl font-bold mb-4" data-id="element-5537">
              Ready to Schedule Your DOT Inspection?
            </h2>
            <p className="text-xl mb-6" data-id="element-5538">
              Ensure your commercial vehicles are road-legal and
              compliant—without the hassle
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-5539">
              <Phone className="mr-3" size={24} data-id="element-5540" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-5541">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}